import { useState } from "react";
import styles from "./TopUpView.module.scss";

interface AddCardFormProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const AddCardForm = ({ onCancel, onSuccess }: AddCardFormProps) => {
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvc, setCvc] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!cardNumber || !expiryDate || !cvc) {
      setError("Заполнены не все поля");
      return;
    }
    // TODO: Add actual card saving logic
    console.log({ cardNumber, expiryDate, cvc });
    onSuccess();
  };

  return (
    <form onSubmit={handleSubmit} className={styles.addCardForm}>
      <div className={styles.paymentInputGroup}>
        <div className={styles.paymentInputLabel}>Номер карты</div>
        <input
          className={`${styles.paymentInput} ${styles.labeledPaymentInput}`}
          placeholder="0000 0000 0000 0000"
          type="text"
          inputMode="numeric"
          value={cardNumber}
          onChange={(e) => setCardNumber(e.target.value)}
        />
      </div>
      <div className={styles.addCardRow}>
        <div className={styles.paymentInputGroup}>
          <div className={styles.paymentInputLabel}>Действует до</div>
          <input
            className={`${styles.paymentInput} ${styles.labeledPaymentInput}`}
            placeholder="мм/гг"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
          />
        </div>
        <div className={styles.paymentInputGroup}>
          <div className={styles.paymentInputLabel}>Код</div>
          <input
            className={`${styles.paymentInput} ${styles.labeledPaymentInput}`}
            placeholder="123"
            type="text"
            inputMode="numeric"
            value={cvc}
            onChange={(e) => setCvc(e.target.value)}
          />
        </div>
      </div>
      <div className={styles.buttons}>
        <button type="submit" className={styles.confirmButton}>
          Сохранить
        </button>
        <button
          type="button"
          onClick={onCancel}
          className={styles.cancelButton}
        >
          Отменить
        </button>
      </div>
      {error && <div className={styles.errorMessage}>{error}</div>}
    </form>
  );
};
